import _ from 'lodash';

import { User } from './user-data-store';

export const fullName = (user: User) => `${user.firstName} ${user.lastName}`;
export const shortName = (user: User) => {
    const firstName = user.firstName;
    const lastName = user.lastName;

    if (firstName && lastName) {
        return `${user.firstName} ${user.lastName.slice(0, 1)}.`;
    }

    if (firstName && !lastName) {
        return firstName;
    }

    if (!firstName && lastName) {
        return lastName;
    }

    return user.username;
}

export const defaultInterfaceLanguage = (user: User) => _.get(user, 'defaultInterfaceLanguage')
export const defaultDataLanguage = (user: User) => _.get(user, 'defaultDataLanguage')
export const defaultWorkspace = (user: User) => _.get(user, 'workspaceMenuResource.principalWorkspace')
export const userWorkspaces = (user: User) => _.get(user, 'workspaceMenuResource.workspaces').concat(_.get(user, 'workspaceMenuResource.workspaceMenus').map(menu => menu.workspaces).flat())